import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { CookieService } from 'ngx-cookie-service';
import { HttpHelperService } from 'src/app/shared/services/http-helper.service';
import { Observable, throwError } from 'rxjs';
import { Router } from '@angular/router';
import { EnvService } from 'src/app/core/services/env.service';
import {CommonService} from 'src/app/shared/services/common.service';
import { JwtHelperService } from '@auth0/angular-jwt';
import { localStorageConstants, localStorageVariables } from 'src/app/core/localStorageConstants/localStorageConstants';
import { LocalStorageService } from 'src/app/core/services/local-storage.service';
import { OAuthService} from 'angular-oauth2-oidc';
import { CallBackTransformService } from 'src/app/core/services/call-back-transform.service';
import { map, catchError } from 'rxjs/operators';

@Injectable({
  providedIn: 'root'
})
export class AuthService {

  jwtToken = 'temptoken';  // Temp token to make it authenticated.
  constructor(
    private envService: EnvService,
    public http: HttpClient,
    public cookieService: CookieService,
    private httpHelperService: HttpHelperService,
    private localStorageService: LocalStorageService,
    public router: Router,
    public commonService: CommonService,
    private oauthService: OAuthService,
    private callBackService: CallBackTransformService
  ) { }

  /**
   * Method to get JWT token assuming JWT auth will be used.
   */
  getToken(): string {
    return this.jwtToken;
  }

  /**
   *
   * @param token Token to be set.
   */
  setToken( token: string) {
    if (token) {
      this.jwtToken = token;
    }
  }

  /**
   * Method to get the autntication status.
   */
  isAutheticated(): boolean {
    if (this.jwtToken) {
      return true;
    } else {
      return false;
    }
  }

  logout(value?) {
    const tenantAbbreviation = this.localStorageService.getDataFromLocalStorage(localStorageVariables.tenantAbbreviation);
    this.cookieService.deleteAll();
    this.localStorageService.deleteAllLocalStorage();
    this.oauthService.logOut(false);
    this.oauthService.revokeTokenAndLogout();
    console.log('this.envService.logoutUrl auth service 65: ', this.envService.logoutUrl);

    window.location.href = this.envService.logoutUrl;
  }

  refreshToken(): Observable<any> {
    // Use the custom API endpoint for token refresh
    const tokenEndpoint = this.envService.apiUrl + 'auth/refresh-token';
    
    // Get refresh token from local storage
    const refreshToken = this.localStorageService.getDataFromLocalStorage(localStorageVariables.refreshToken);
    
    // Create JSON payload
    const requestBody = {
      refreshToken: refreshToken
    };
    
    // Create the request headers for JSON
    const headers = {
      'Content-Type': 'application/json'
    };
    
    // Make the HTTP request to refresh the token with proper response transformation
    return this.http.post<any>(tokenEndpoint, requestBody, { headers, withCredentials: true }).pipe(
      map(output => this.callBackService.transformOutput(output)),
      catchError(err => throwError(this.callBackService.transformOutput(err)))
    );
  }

  setLocalStorage(accessToken) {
    const helper = new JwtHelperService();
    const decodedToken = helper.decodeToken(accessToken);
    if (decodedToken) {
      this.localStorageService.saveInLocalStorage(localStorageVariables.token, accessToken);
      this.localStorageService.saveInLocalStorage(localStorageVariables.role, decodedToken.extension_role);
      this.localStorageService.saveInLocalStorage(localStorageVariables.email, decodedToken.email);
      this.localStorageService.saveInLocalStorage(localStorageVariables.agencyId, decodedToken.extension_tenantId);
      this.localStorageService.saveInLocalStorage(localStorageVariables.Tenant, decodedToken.extension_tenantId);
      this.localStorageService.saveInLocalStorage(localStorageVariables.agencyName, decodedToken.extension_agency);
      this.localStorageService.saveInLocalStorage(localStorageVariables.UserId, decodedToken.extension_userId);
      this.localStorageService.saveInLocalStorage(localStorageVariables.tenantAbbreviation, decodedToken.extension_tenantAbbreviation);
      this.localStorageService.saveInLocalStorage(localStorageVariables.defaultAgency, decodedToken.extension_tenantId);
      this.localStorageService.saveInLocalStorage(localStorageVariables.setDefaultAgency, 'true');
      this.localStorageService.saveInLocalStorage(localStorageVariables.authenticationSource, decodedToken?.authenticationSource);
    }
  }
  setSessionStorage(accessToken) {
    const helper = new JwtHelperService();
    const decodedToken = helper.decodeToken(accessToken);
    if (decodedToken) {
      this.localStorageService.saveSessionStorage(localStorageVariables.token, accessToken);
      this.localStorageService.saveSessionStorage(localStorageVariables.role, decodedToken.extension_role);
      this.localStorageService.saveSessionStorage(localStorageVariables.email, decodedToken.email);
      this.localStorageService.saveSessionStorage(localStorageVariables.agencyId, decodedToken.extension_tenantId);
      this.localStorageService.saveSessionStorage(localStorageVariables.Tenant, decodedToken.extension_tenantId);
      this.localStorageService.saveSessionStorage(localStorageVariables.agencyName, decodedToken.extension_agency);
      this.localStorageService.saveSessionStorage(localStorageVariables.UserId, decodedToken.extension_userId);
      this.localStorageService.saveSessionStorage(localStorageVariables.tenantAbbreviation, decodedToken.extension_tenantAbbreviation);
      this.localStorageService.saveSessionStorage(localStorageVariables.defaultAgency, decodedToken.extension_tenantId);
      this.localStorageService.saveSessionStorage(localStorageVariables.setDefaultAgency, 'true');
      this.localStorageService.saveSessionStorage(localStorageVariables.authenticationSource, decodedToken?.authenticationSource);
    }
  }
  
}
